export default {
  url: 'https://accounts.google.com/o/oauth2/auth?hd=nulogy.com',
  client: process.env.REACT_APP_CLIENT_ID,
  client_secret: process.env.REACT_APP_CLIENT_SECRET,
  redirect: process.env.REACT_APP_REDIRECT_URI,
  scope: 'email',
};



// WEBPACK FOOTER //
// ./src/auth.config.js